export default __webpack_public_path__ + "assets/images/Invoice-f1695191e4c4eb30b0a0f4c7477b37ff.svg";